import { THEME_DEVICE_NAMES } from '../enums/devices';
import {
  THEME_TYPOGRAPHY_ATTRIBUTE_NAMES,
  THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES,
  THEME_TYPOGRAPHY_VARIANT_NAMES,
} from '../enums/typography';

/**
 * @name THEME_TYPOGRAPHY_FONT_LIGHT
 * @description default Light font
 */
const THEME_TYPOGRAPHY_FONT_LIGHT = {
  [THEME_TYPOGRAPHY_ATTRIBUTE_NAMES.FONT_FAMILY]: "'Light', arial, sans-serif",
  [THEME_TYPOGRAPHY_ATTRIBUTE_NAMES.FONT_WEIGHT]: 300,
};

/**
 * @name THEME_TYPOGRAPHY_FONT_REGULAR
 * @description default Light font
 */
const THEME_TYPOGRAPHY_FONT_REGULAR = {
  [THEME_TYPOGRAPHY_ATTRIBUTE_NAMES.FONT_FAMILY]:
    "'Regular', arial, sans-serif",
  [THEME_TYPOGRAPHY_ATTRIBUTE_NAMES.FONT_WEIGHT]: 400,
};

/**
 * @name THEME_TYPOGRAPHY_FONT_BOLD
 * @description default Light font
 */
const THEME_TYPOGRAPHY_FONT_BOLD = {
  [THEME_TYPOGRAPHY_ATTRIBUTE_NAMES.FONT_FAMILY]: "'Bold', arial, sans-serif",
  [THEME_TYPOGRAPHY_ATTRIBUTE_NAMES.FONT_WEIGHT]: 700,
};

/**
 * @name THEME_TYPOGRAPHY
 * @description default typography values by device
 */
export const THEME_TYPOGRAPHY = {
  [THEME_TYPOGRAPHY_VARIANT_NAMES.DISPLAY1]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['4rem', '4.5rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['2.5rem', '3rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.DISPLAY2]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['3.375rem', '4rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['2.5rem', '2.875rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.DISPLAY3]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['2.5rem', '3rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['2rem', '2.5rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.H1]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['2.5rem', '3rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['2rem', '2.5rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.H2]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['2.5rem', '3rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['1.75rem', '2rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.H3]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['2rem', '2.5rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['1.5rem', '2rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.H4]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['1.75rem', '2rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['1.375rem', '1.5rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.H5]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['1.25rem', '1.75rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['1.125rem', '1.5rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.H6]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['1.125rem', '1.5rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['1rem', '1.5rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.BODY1]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['1.25rem', '1.75rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['1.125rem', '1.5rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.BODY2]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['1.125rem', '1.5rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['1rem', '1.5rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.BODY3]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['1rem', '1.5rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['0.875rem', '1.25rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.BODY4]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['0.875rem', '1.25rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['0.75rem', '1rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.CAPTION1]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['1rem', '1.5rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['0.875rem', '1.25rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.CAPTION2]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['0.875rem', '1.25rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['0.75rem', '1rem'],
    }
  ),
  [THEME_TYPOGRAPHY_VARIANT_NAMES.CAPTION3]: createTypography(
    {
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.LIGHT]: THEME_TYPOGRAPHY_FONT_LIGHT,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.REGULAR]:
        THEME_TYPOGRAPHY_FONT_REGULAR,
      [THEME_TYPOGRAPHY_FONT_WEIGHT_NAMES.BOLD]: THEME_TYPOGRAPHY_FONT_BOLD,
    },
    {
      [THEME_DEVICE_NAMES.DESKTOP]: ['0.75rem', '0.75rem'],
      [THEME_DEVICE_NAMES.MOBILE]: ['0.625rem', '0.625rem'],
    }
  ),
};

/**
 * @name createTypography
 * @description auxiliary
 * @param {any} fonts
 * @param {any} devices
 * @returns {any}
 */
function createTypography(fonts = {}, devices = {}) {
  const fontCSSRule = Object.keys(fonts).reduce(
    (acc, key) => ({
      ...acc,
      [key]: fonts[key],
    }),
    {}
  );

  const deviceCSSRule = Object.keys(devices).reduce(
    (acc, key) => ({
      ...acc,
      [key]: {
        [THEME_TYPOGRAPHY_ATTRIBUTE_NAMES.FONT_SIZE]: devices[key][0],
        [THEME_TYPOGRAPHY_ATTRIBUTE_NAMES.LINE_HEIGHT]: devices[key][1],
      },
    }),
    {}
  );

  return {
    ...fontCSSRule,
    ...deviceCSSRule,
  };
}
